const DEFAULT_PROGRESS_BAR_CLASS_NAME = 'default-progress-bar';
export default DEFAULT_PROGRESS_BAR_CLASS_NAME;
